// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__23Iq5","modal":"Modal_modal__BwL-9","header":"Modal_header__BU-Av","body":"Modal_body__UsNOr","footer":"Modal_footer__4SMVN","close":"Modal_close__nXyvo"};